import React from 'react';

class SearchInputItem extends React.Component {

    state = {
        showCheck: false
    };

    switchToCheck() {
        const that = this;
        this.setState({
            showCheck: true
        });
        setTimeout(function() {
            that.setState({
                showCheck: false
            })
        }, 2000);
    }

    clickHandler() {
        this.switchToCheck();
        this.props.clickHandler(this.props.item);
    }

    getPrice() {
        if (this.props.item.is_on_sale) {
            return (
                <>
                    <div className="text-fifth-red">
                        {this.props.item.price.prepend}
                        <span className="booking-service__price">{this.props.item.sales_price.value} </span>
                        {this.props.item.price.append}
                    </div>
                    <div className="text-xs line-through">
                        {this.props.item.price.prepend}
                        <span className="booking-service__price">{this.props.item.price.value} </span>
                        {this.props.item.price.append}
                    </div>
                </>
            );
        } else {
            return (
                <span className="booking-service__price">{this.props.item.price.prepend}{this.props.item.price.value} {this.props.item.price.append}</span>
            );
        }
    }

    showPlus() {
        return <span><i className={'fas inline-block fa-plus'} /></span>;
    }
    showCheck() {
        return <span><i className={'fas inline-block fa-check'} /></span>;
    }

    render() {
        if (this.props.item.is_hidden_from_list) {
            return null;
        }
        return (
            <div className="search-input__result flex items-center" onClick={() => this.clickHandler()}>
                <div className="flex-1 text-left">
                    <div>{this.props.item.title}</div>
                    <small>from {this.props.item.category}</small>
                </div>
                <ul>
                    <li className="search-input__result-price">
                        {this.getPrice()}
                    </li>
                    <li>
                        <div className="flex items-center justify-center btn btn-red">
                            {this.state.showCheck === true && this.showCheck()}
                            {this.state.showCheck === false && this.showPlus()}
                        </div>
                    </li>
                </ul>
            </div>
        )
    }
}

export default SearchInputItem;



// WEBPACK FOOTER //
// ./scripts/components/SearchInputItem.jsx